import { NavItem, SocialLink } from '../types';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

export const navigationItems: NavItem[] = [
  {
    id: 'home',
    label: 'Home',
    href: '#home'
  },
  {
    id: 'about',
    label: 'About',
    href: '#about'
  },
  {
    id: 'technologies',
    label: 'Technologies',
    href: '#technologies'
  },
  {
    id: 'projects',
    label: 'Projects',
    href: '#projects'
  },
  {
    id: 'contact',
    label: 'Contact',
    href: '#contact'
  }
];

export const socialLinks: SocialLink[] = [
  {
    name: 'GitHub',
    url: 'https://github.com/jeremiahmanuel',
    icon: FaGithub
  },
  {
    name: 'LinkedIn', 
    url: 'https://www.linkedin.com/in/jeremiah-manuel-49176014a/',
    icon: FaLinkedin
  }
];

// Future navigation items (for blog, etc.)
export const futureNavItems: NavItem[] = [
  {
    id: 'blog',
    label: 'Blog',
    href: '#blog'
  }
]; 